import { useMemo } from 'react';

import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import { createAction } from '~/techstyle-shared/redux-core';

const getNearestColorTagsByColorValuesRequest = createAction(
  'getNearestColorTagsByColorValuesRequest'
);
const getNearestColorTagsByColorValuesSuccess = createAction(
  'getNearestColorTagsByColorValuesSuccess'
);
const getNearestColorTagsByColorValuesFailure = createAction(
  'getNearestColorTagsByColorValuesFailure'
);

function getNearestColorTagsByColorValues({ r, g, b }) {
  return {
    bentoApi: {
      endpoint: `tags/nearest-colors`,
      method: 'GET',
      searchParams: {
        r,
        g,
        b,
        size: 100,
        maxDistance: 12,
      },
      actions: [
        getNearestColorTagsByColorValuesRequest,
        getNearestColorTagsByColorValuesSuccess,
        getNearestColorTagsByColorValuesFailure,
      ],
    },
  };
}

export default function useColorActions() {
  const dispatch = useDispatch();
  const actions = useMemo(() => {
    return bindActionCreators(
      {
        getNearestColorTagsByColorValues,
      },
      dispatch
    );
  }, [dispatch]);
  return actions;
}
